// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Radio from 'common/domain/radio';
import { Card } from 'statsradio/themes/v3/Stylesheet';
import Page from 'statsradio/components/page/v2/Page';
import MetricsParameters from './components/parameters/MetricsParameters';
import { DEFAULT_METRICS_QUERY, MetricsQuery } from '../domain/Metrics';
import ReachService from '../services/ReachService';
import MetricsOverviewSection from './components/reachMetricsOverview/MetricsOverviewSection';

const Wrapper = styled.div`
`;

const Section = styled.div`
`;

const MetricsSelectorWrapper = styled.div`
  margin: ${({ theme }) => theme.V3.metrics.margin.large}px 0;
`;

const MetricsCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.V3.metrics.margin.normal}px;
  padding: ${({ theme }) => theme.V3.metrics.margin.normal}px;
`;

interface Props {
  radio: Radio;
  token: string;

  t: (key: string) => string;
}

interface State {
  query: MetricsQuery;
  error?: Object;
  isFetching?: boolean;

  metrics: {
    missingSampling: boolean;

    totalReach: Object;
    averageTotalReach: Object;
    averageQuarterHourReach: Object;
    reachByInterval: Object;
  } | void
}

const DEFAULT_STATE = {
  query: DEFAULT_METRICS_QUERY,
  metrics: undefined,
};

class ReachPage extends React.Component<Props, State> {
  state = DEFAULT_STATE;

  componentDidMount() {
    this.fetchMetrics(this.state.query);
  }

  componentDidUpdate(prevProps: Props) {
    if (!this.props.radio.isSame(prevProps.radio)) {
      this.clearMetrics();
      this.fetchMetrics(this.state.query);
    }
  }

  clearMetrics = () => this.setState({ metrics: undefined, error: undefined, isFetching: false });

  fetchMetrics = (query: MetricsQuery) => {
    const { radio, token } = this.props;

    this.setState({ query, error: undefined, isFetching: true });
    return ReachService.fetchReachMetrics(radio, token, query)
      .then(metrics => this.setState({ metrics, isFetching: false }))
      .catch(error => this.setState({ metrics: undefined, error, isFetching: false }));
  };

  onMetricsParametersChange = (query: MetricsQuery) => {
    this.setState({ query });
    this.clearMetrics();
    this.fetchMetrics(query);
  };

  render() {
    const { dateRange, dateRangeCompared } = this.state.query;
    const metrics = this.state.metrics;
    return (
      <Page title={this.props.t('reachPageTitle')}>
        <Wrapper>
          <Section>
            <MetricsSelectorWrapper>
              <MetricsParameters
                query={this.state.query}
                onChange={this.onMetricsParametersChange}
              />
            </MetricsSelectorWrapper>
          </Section>
          <MetricsOverviewSection dateRange={dateRange} dateRangeCompared={dateRangeCompared} metrics={metrics} />
          <Section>
            <MetricsCard>TODO</MetricsCard>
          </Section>
        </Wrapper>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    radio: state.session.radio,
    token: state.session.token,
  };
}

export default translate('metrics')(connect(mapStateToProps)(ReachPage));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/ReachPage.js